import React from 'react'
import {Link, navigateTo} from 'gatsby-link'

import {Navbar, Nav, NavItem} from 'react-bootstrap'

export default class Navigoat extends React.Component {
  render() {
    const active_tab = this.props.active_tab;
    return (
      <Navbar collapseOnSelect>
        <Navbar.Header>
          <div id="title-name">Robert Pienta</div>
        <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <NavItem onClick={ () => navigateTo('/')}
                     active={active_tab === 'about'}
                     eventKey={1}>
              <span className="julius"> ABOUT </span>
            </NavItem>
            <NavItem onClick={ () => navigateTo('/gallery/')}
                     active={active_tab === 'gallery' }
                     eventKey={2}>
              <span className="julius"> GALLERY </span>
            </NavItem>
            <NavItem onClick={ () => navigateTo('/projs/')}
                     active={active_tab === 'projs' }
                     eventKey={3}>
              <span className="julius"> PROJECTS </span>
            </NavItem>
            <NavItem onClick={ () => navigateTo('/contact/')}
                     active={active_tab === 'contact' }
                     eventKey={4}>
              <span className="julius"> CONTACT </span>
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
};
//
// <nav className="navbar navbar-default navbar-fixed-top" role="navigation">
//   <div className="container-fluid">
//     <div className="navbar-header">
//       <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#collapse-target-menu" type="button" id="menu-btn-mage">
//         <span className="sr-only">Toggle navigation</span>
//         <span className="icon-bar"></span>
//         <span className="icon-bar"></span>
//         <span className="icon-bar"></span>
//       </button>
//       <p className="navbar-text" id="title-name">Robert Pienta</p>
//     </div>
//
//     <div className="collapse navbar-collapse navbar-responsive-collapse" id="collapse-target-menu">
//       <ul className="nav navbar-nav pull-right">
//         <li id="nomarg" className = { active_tab === 'about' ? 'active' : '' }>
//           <Link id="MenuLinkText" to="/">ABOUT</Link>
//         </li>
//         <li id="nomarg" className = { active_tab === 'gallery' ? 'active' : ''}>
//           <Link id="MenuLinkText" to="/gallery/">GALLERY</Link>
//         </li>
//         <li  id="nomarg" className = { active_tab === 'projs' ? 'active' : ''}>
//           <Link id="MenuLinkText" to="/projs/">PROJECTS</Link>
//         </li>
//         <li id="nomarg" className = { active_tab === 'contact' ? 'active' : ''}>
//           <Link id="MenuLinkText" to="/contact/">CONTACT</Link>
//         </li>
//       </ul>
//     </div>
//   </div>
// </nav>



// WEBPACK FOOTER //
// ./src/layouts/navigoat.js